// Datos estáticos de contacto — fuente: DatosPrincipales.docx
export const TEL1 = '011 6793-1464';
export const TEL2 = '011 6568-3169';
export const TEL1_TEL = '+541167931464';
export const TEL2_TEL = '+541165683169';
export const EMAIL = 'lacarlareservas@gmail.com';
export const EMAIL_RESERVAS = 'lacarlareservas@gmail.com';
export const IG = 'https://www.instagram.com/fincalacarla/';
export const FB = 'https://www.facebook.com/profile.php?id=61582360713302';
export const MAPS_LINK = 'https://maps.app.goo.gl/KdxJ1RJG39jp4LENA';
export const MAPS_IFRAME =
  'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d27905.879613047222!2d-66.02427990229542!3d-25.990935868559504!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x941f2db2ee139581%3A0xb0cc92bdbbfe1bb9!2sFinca%20La%20Carla!5e0!3m2!1ses-419!2sar!4v1785346621882!5m2!1ses-419!2sar';

export function waLink(texto) {
  return `https://wa.me/541167931464?text=${encodeURIComponent(texto)}`;
}